<ctx-app-bar-base [sideNavShow]="false">
  <span class="hidden md:flex flex-row gap-2">
    @if (showGoToWebsite) {
    <button
      ctx-button--secondary
      color="primary"
      size="sm"
      navIcon="NAVIGATE_TO"
      (click)="goToWebsite()"
    >
      Back to website
    </button>
    } @if (showSignup) {
    <button
      ctx-button--secondary
      color="primary"
      size="sm"
      navIcon="SIGNUP"
      [routerLink]="['/auth/signup']"
    >
      Sign up
    </button>
    } @if (showLogin) {
    <button
      ctx-button--secondary
      color="primary"
      size="sm"
      navIcon="LOGIN"
      [routerLink]="['/auth/login']"
    >
      Log in
    </button>
    }
  </span>
</ctx-app-bar-base>
<main class="block max-w-sm mx-auto px-4 mt-8">
  <router-outlet></router-outlet>
</main>
